/* global HSCore */

import React, { useContext, useEffect, useRef } from "react";
import { isEqual } from "lodash";
import { formatThousand } from "../../../../utils";
import LanguageContext from "../../../../utils/Contexts/LanguageContext";

import "./style.css";

const ContractProgress = ({ seller, basicDetails }) => {
  const { da, dr, traffic } = basicDetails;
  const { t } = useContext(LanguageContext);
  const convertSeconds = (seconds) => {
    if (seconds < 0 || seconds === null || undefined) return "0s";
    if (seconds < 60) {
      return `${seconds}s`;
    } else if (seconds < 3600) {
      const minutes = Math.floor(seconds / 60);
      return `${minutes}m`;
    } else {
      const hours = Math.floor(seconds / 3600);
      return `${hours}h`;
    }
  };

  const previousDataRef = useRef(null);
  useEffect(() => {
    const handleResize = () => {
      const root = document.documentElement;
      const cardBgColor = getComputedStyle(root).getPropertyValue("--border");
      const circleColors = [
        { fillColor: "#ED864C", backgroundColor: "var(--border)" },
        { fillColor: "#387CFF", backgroundColor: "var(--border)" },
      ];

      document.querySelectorAll(".js-circle").forEach((item, index) => {
        const options = {
          value: parseInt(item.getAttribute("data-value")),
          maxValue: 100,
          duration: 2000,
          isViewportInit: true,
          colors: [
            circleColors[index].backgroundColor,
            circleColors[index].fillColor,
          ],
          radius: window.innerWidth <= 1024 ? 50 : 40,
          width: 10,
          additionalText: "",
          textFontSize: 24,
          textClass: "circles-chart-content",
          textColor: cardBgColor,
          fgStrokeLinecap: "round",
        };

        HSCore.components.HSCircles.init(item, options);
      });
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Initial render
    if (!isEqual(previousDataRef.current, basicDetails)) {
      previousDataRef.current = basicDetails;
      handleResize();
    }

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [basicDetails]);

  return (
    <div>
      <div className="progress_main_cont">
        <div className="progress_main">
          <div className="js-circle" data-value={dr || 50}></div>
          <div className="js-circle" data-value={da || 50}></div>
        </div>
        <div className="progress_content">
          <div>
            <h4>{seller && (convertSeconds(seller?.tat) || 0)}</h4>
            <p>{t("TAT")}</p>
          </div>
          <div>
            <h4>{seller?.links_alive || 0}%</h4>

            <p>{t("Links Stay")}</p>
          </div>
          <div>
            <h4>{traffic ? formatThousand(traffic) : 0}</h4>
            <p>{t("Monthly Traffic")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractProgress;
